<template>
  <div>
    <h1>Aging Stock</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- Aging Stock Analysis Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Aging Stock Analysis</h5>
      <aging-stock-analysis
        :filterUrl="filterUrl"
      ></aging-stock-analysis>
    </div>
    <!-- Aging Stock Analysis End -->

    <!-- Aging Range & Time By Category Start -->
    <aging-range-by-category
      :filterUrl="filterUrl"
    ></aging-range-by-category>
    <!-- Aging Range & Time By Category End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import agingStockAnalysis from './children/agingStockAnalysis'
  import agingRangeByCategory from './children/agingRangeByCategory'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      agingStockAnalysis,
      agingRangeByCategory,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>